import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ApiService } from '../api.service'

@Component({
  selector: 'app-success-post',
  templateUrl: './success-post.component.html',
  styleUrls: ['./success-post.component.scss']
})
export class SuccessPostComponent implements OnInit {
  JobId:string;
  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService) { }

  ngOnInit() {

    this.JobId = this.activatedRoute.snapshot.paramMap.get("JobId");     
    

  }

  getJobNumber(JobId: string) {
    return 'SC-JOB-' + JobId.toString().padStart(8, '0');
  }

  ViewEnquiryDetails(){
    
  }

}
